import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import LawSourceAttribution from './attribution/LawSourceAttribution';
import QASourceAttribution from './attribution/QASourceAttribution';

const ADMIN_EMAIL = 'safetyacademy.admin@gmail.com';

function Footer() {
  const { pathname } = useLocation();
  const isLawDetail =
    /^\/safety-regulations\/[^/]+$/.test(pathname) &&
    !pathname.includes('/qa') &&
    pathname !== '/safety-regulations';
  const isQaSection = pathname.includes('/safety-regulations/qa');

  return (
    <footer className="mt-6 border-t border-gray-200 bg-gray-50" role="contentinfo">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 py-5">
        {(isLawDetail || isQaSection) && (
          <div className="max-w-3xl mx-auto mb-5 text-left space-y-3">
            {isLawDetail && <LawSourceAttribution variant="compact" />}
            {isQaSection && (
              <QASourceAttribution
                variant="compact"
                isConstruction={pathname.includes('qa-construction')}
              />
            )}
          </div>
        )}
        <div className="text-center">
          <p className="text-sm font-semibold text-gray-900">Safety Academy</p>
          <p className="mt-2 text-sm text-gray-600">
            <span className="text-gray-500">관리자 메일</span>
            {' · '}
            <a
              className="text-blue-700 underline underline-offset-2 decoration-blue-700/40 hover:text-blue-800 hover:decoration-blue-800"
              href={`mailto:${ADMIN_EMAIL}`}
            >
              {ADMIN_EMAIL}
            </a>
          </p>
          <p className="mt-1 text-xs text-gray-500">사이트 운영 및 문의는 위 주소로 보내 주시면 됩니다.</p>
          <div className="mt-3 text-xs sm:text-sm text-gray-500">
            <Link className="hover:text-gray-700" to="/privacy-policy">개인정보처리방침</Link>
            {' | '}
            <Link className="hover:text-gray-700" to="/terms">이용약관</Link>
            {' | '}
            <Link className="hover:text-gray-700" to="/contact">문의</Link>
          </div>
          <p className="mt-2 text-xs text-gray-400">
            Copyright {new Date().getFullYear()} Safety Academy. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
